<header class="header">
  <div class="container">
    <div class="header-content">
      <div class="brand">
        <div class="logo">
          <img src="EM-Zoll Logo.png" alt="EM Zoll Logistik GmbH Logo" class="logo-image">
        </div>
        <div class="brand-info">
          <h1 class="brand-title">EM Zoll Logistik GmbH</h1>
          <p class="brand-subtitle" i18n>Ihr Partner für grenzüberschreitenden Handel</p>
        </div>
      </div>
      
      <nav class="main-nav">
        <!-- Sprachumschalter (Dropdown) im Header, nicht im Menü -->
        <div class="lang-switcher" (keydown.escape)="closeLang()">
          <button
            class="lang-button"
            (click)="toggleLang()"
            [attr.aria-expanded]="langOpen()"
            aria-haspopup="listbox"
            i18n-aria-label="@@ui.language"
            aria-label="Sprache">
            <ion-icon name="globe-outline" class="lang-icon"></ion-icon>
            <span class="lang-label">{{ currentLocaleLabel }}</span>
            <ion-icon name="chevron-down" class="lang-caret"></ion-icon>
          </button>

          <ul class="lang-menu" [class.open]="langOpen()" role="listbox">
            <li><a href="#" (click)="changeLocale('de'); $event.preventDefault()" [class.active]="currentLocale==='de'" role="option" [attr.aria-selected]="currentLocale==='de'">Deutsch</a></li>
            <li><a href="#" (click)="changeLocale('en'); $event.preventDefault()" [class.active]="currentLocale==='en'" role="option" [attr.aria-selected]="currentLocale==='en'">English</a></li>
            <li><a href="#" (click)="changeLocale('tr'); $event.preventDefault()" [class.active]="currentLocale==='tr'" role="option" [attr.aria-selected]="currentLocale==='tr'">Türkçe</a></li>
            <li><a href="#" (click)="changeLocale('sr-Latn'); $event.preventDefault()" [class.active]="currentLocale==='sr-Latn'" role="option" [attr.aria-selected]="currentLocale==='sr-Latn'">Srpski</a></li>
            <li><a href="#" (click)="changeLocale('bs'); $event.preventDefault()" [class.active]="currentLocale==='bs'" role="option" [attr.aria-selected]="currentLocale==='bs'">Bosanski</a></li>
            <!-- Bulgarische Sprache entfernt -->
          </ul>
        </div>

        <button class="mobile-toggle" (click)="toggleMenu()" [class.active]="menuOpen()" [attr.aria-expanded]="menuOpen()" [attr.aria-label]="menuOpen() ? 'Menü schließen' : 'Menü öffnen'" aria-controls="main-navigation">
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div id="main-navigation" class="nav-links" [class.open]="menuOpen()">
          <!-- Revert to hash anchors for section navigation; keep manual active handling -->
          <a href="#hero" (click)="scrollToSection('hero')" i18n>Startseite</a>
          <a href="#ueber-uns" (click)="scrollToSection('ueber-uns')" i18n>Über uns</a>
          <a href="#dienstleistungen" (click)="scrollToSection('dienstleistungen')" i18n>Dienstleistungen</a>
          <a href="#links" (click)="scrollToSection('links')" i18n>Links</a>
          <a href="#kontakt" (click)="scrollToSection('kontakt')" class="headerctabutton" i18n>Kontakt</a>
        </div>
      </nav>
    </div>
  </div>
</header>

<router-outlet></router-outlet>

<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <div class="footer-section">
        <h3 class="footer-title">EM Zoll Logistik GmbH</h3>
        <p class="footer-text" i18n>Ihr zuverlässiger Partner für Zollabfertigung und Logistiklösungen in Bayern.</p>
        <div class="footer-contact">
          <p><strong i18n>Adresse:</strong><br>Hartham 1<br>94152 Neuhaus am Inn</p>
            <p><strong i18n>Telefon:</strong><br><a href="tel:+491601254970">+49 160 1254970</a></p>
        </div>
      </div>
      
      <div class="footer-section">
        <h3 class="footer-title" i18n>Navigation</h3>
        <ul class="footer-links">
          <li><a href="#hero" (click)="scrollToSection('hero')" i18n>Startseite</a></li>
          <li><a href="#ueber-uns" (click)="scrollToSection('ueber-uns')" i18n>Über uns</a></li>
          <li><a href="#dienstleistungen" (click)="scrollToSection('dienstleistungen')" i18n>Dienstleistungen</a></li>
          <li><a href="#links" (click)="scrollToSection('links')" i18n>Hilfreiche Links</a></li>
          <li><a href="#kontakt" (click)="scrollToSection('kontakt')" i18n>Kontakt</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h3 class="footer-title" i18n>Rechtliches</h3>
        <ul class="footer-links">
          <li><a routerLink="/impressum" routerLinkActive="active" i18n>Impressum</a></li>
          <li><a routerLink="/datenschutz" routerLinkActive="active" i18n>Datenschutz</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h3 class="footer-title" i18n>Servicezeiten</h3>
        <p class="footer-text" i18n>Mo - Fr: 06:00 - 22:00 Uhr<br>
        Sa: 08:00 - 13:00 Uhr<br>
        So: Geschlossen</p>
      </div>
    </div>
    
    <div class="footer-bottom">
      <p i18n>&copy; 2024 EM Zoll Logistik GmbH. Alle Rechte vorbehalten.</p>
      <div class="footer-bottom-links">
        <a routerLink="/impressum" routerLinkActive="active" i18n>Impressum</a>
        <span>|</span>
        <a routerLink="/datenschutz" routerLinkActive="active" i18n>Datenschutz</a>
      </div>
    </div>
  </div>
</footer>


